import React from 'react';
import styled from 'styled-components';
import { colorAccent } from '../../utils/palette';

const BlockContainer = styled.div`
  display: flex;
  gap: 12px;
  padding: 20px;
  justify-content: center;
  align-items: center;
`;

const NumberBox = styled.div`
  width: 50px;
  height: 50px;
  background-color: ${colorAccent};
  color: white;
  font-size: 1.5rem;
  font-weight: bold;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

export const NumberBlock = ({ value }) => {
  const valueStr = String(value);
  const digits = valueStr.slice(0, 6).split('');

  return (
    <BlockContainer>
      {digits.map((digit, idx) => (
        <NumberBox key={idx}>{digit}</NumberBox>
      ))}
    </BlockContainer>
  );
};
